<script>
	import { Canvas } from 'svelte-canvas';
	// interface
	import Notes from './Notes.svelte';
	import Settings from './interface/Settings.svelte';
	import DownloadButton from './interface/DownloadButton.svelte';
	// canvas
	import Calendar from './canvas/Calendar.svelte';
	import Background from './canvas/Background.svelte';
	import { width, height } from './stores.js';

	let svelteCanvas;
</script>

<div class="app">
	<!-- form -->
	<div>
		<Settings {svelteCanvas} />
		<DownloadButton {svelteCanvas} />
	</div>
	<!-- canvas -->
	<div class="svelte-canvas">
		<Canvas bind:this={svelteCanvas} width={$width} height={$height}>
			<Background {svelteCanvas} />
			<Calendar/>
		</Canvas>
	</div>
</div>

<!-- <Notes/> -->


<style>
	.app {
		display: grid;
		gap: 1em;
		grid-template-columns: 11em auto;
	}
	.svelte-canvas {
		max-width: 100%;
	}
</style>
